import { useMemo, useState } from "react";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { useDebouncedState } from "../../../../../utilities/hooks/useDebouncedState";
import { ORDER_TYPES } from "../../../../../consts/api";
import { useShopifyPatientOrdersReportQuery } from "../../../../../api/shopifyReports/useShopifyPatientOrdersReportQuery";
import { uiNotification } from "../../../../../services/UINotificationService";

const prepareReqOrder = (orderState) => {
  if (Object.values(orderState).every(Boolean)) {
    return {
      by: orderState.by,
      direction: orderState.direction,
    };
  }
  return null;
};

export function useReport(patientId) {
  var { tClients: t } = useAppTranslation.Clients();

  var { 0: search, 1: debouncedSearch, 2: setSearch } = useDebouncedState("");

  var { 0: order, 1: setOrder } = useState({
    by: "",
    direction: "",
  });

  var updateOrder = (orderFieldKey) => {
    setOrder({
      by: orderFieldKey,
      direction:
        order.direction === ORDER_TYPES.desc
          ? ORDER_TYPES.asc
          : ORDER_TYPES.desc,
    });
  };

  var {
    data,
    isLoading,
    isFetching,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useShopifyPatientOrdersReportQuery({
    payload: {
      pageSize: 15,
      patientId: Number(patientId),
      search: debouncedSearch,
      order: prepareReqOrder(order),
    },
    options: {
      staleTime: 0,
      cacheTime: 0,
      keepPreviousData: true,
      onError: () => {
        uiNotification.error(t("shopify_orders.error.fetch"));
      },
    },
  });

  var reports = useMemo(() => {
    if (data?.pages) {
      return data.pages
        .map((p) => p.reports)
        .reduce((r, p) => [...r, ...p], []);
    }
    return [];
  }, [data?.pages]);

  var isSoftLoading = isFetching && !isLoading && !isFetchingNextPage;

  return {
    reports: {
      value: reports,
      isLoading,
      isSoftLoading,
      hasMore: Boolean(hasNextPage),
      isNextFetching: isFetchingNextPage,
      fetchMore: fetchNextPage,
    },
    search: {
      value: search,
      update: setSearch,
    },
    order: {
      value: order,
      update: updateOrder,
    },
  };
}
